import AppDispatcher from "../dispatcher/AppDispatcher";

import AppConstants from "../constants/AppConstants";

import AccountStore from "../stores/AccountStore";

import Api from "../utils/Api";

// AccountActions
export default
{
	async getAccounts(kebabAccountName)
	{
		const accounts = await Api.getAccounts();

		AppDispatcher.handleAction({
			actionType: AppConstants.RECEIVE_DATA,
			kebabAccountName,
			accounts: accounts
		});
		const selectedAccount = AccountStore.getSelected();
		if (selectedAccount)
		{
			await this.getLineItems(selectedAccount.id);
		}
	},

	// Set currently selected account
	async selectAccount(index, sort, search)
	{
		AppDispatcher.handleAction({
			actionType: AppConstants.SELECT_ACCOUNT,
			data: index
		});
		const selectedAccount = AccountStore.getSelected();
		if (selectedAccount && selectedAccount.id)
		{
			await this.getLineItems(selectedAccount.id, /*pageIndex*/ 0, sort, search);
		}
	},

	async saveAccount(account)
	{
		AppDispatcher.handleAction({
			actionType: AppConstants.ACCOUNTS_SAVE_PENDING
		});

		account = await Api.saveAccount(account);
		AppDispatcher.handleAction({
			actionType: AppConstants.ACCOUNTS_SAVE_SUCCESS,
			account
		});
	},

	async getLineItems(accountId, pageIndex, sort, search)
	{
		const lineItemsPaged = await Api.getAccountLineItems(accountId, pageIndex, sort, search);

		AppDispatcher.handleAction({
			actionType: AppConstants.ACCOUNTS_RECEIVE_LINEITEMS,
			lineItems: lineItemsPaged.results,
			paging: lineItemsPaged.paging
		});
	},

	async saveLineItem(account, lineItem)
	{
		// TODO: BA-160 set overlay
		// Optimistic update, set overlay
		AppDispatcher.handleAction({
			actionType: AppConstants.ACCOUNT_LINEITEM_SAVE_PENDING,
			account,
			lineItem
		});

		try
		{
			const lineItemReturned = await Api.saveAccountLineItem(account, lineItem);
			await this.reloadAccountsAndBudgetAllocations(account.id);
			AppDispatcher.handleAction({
				actionType: AppConstants.ACCOUNT_LINEITEM_SAVE_SUCCESS,
				lineItem: lineItemReturned
			});
		}
		catch (message)
		{
			AppDispatcher.handleAction({
				actionType: AppConstants.ACCOUNT_LINEITEM_SAVE_FAILURE,
				message
			});
		}
	},

	async saveTransaction(transaction)
	{
		try
		{
			const transactionResult = await Api.saveTransaction(transaction);
			await this.reloadAccountsAndBudgetAllocations(transaction.accountId);
			this.transactionSaved(transactionResult);
		}
		catch (message)
		{
			// TODO: BA-152 handle error
			console.error(message);
		}
	},

	async reloadAccountsAndBudgetAllocations(selectedAccountId)
	{
		try
		{
			const [budgetAllocations, accounts] =
				await Promise.all([Api.getBudgetAllocations(), Api.getAccounts()]);

			AppDispatcher.handleAction({
				actionType: AppConstants.RELOAD_DATA,
				selectedAccountId,
				budgetAllocations,
				accounts
			});
		}
		catch (err)
		{
			// TODO: BA-152 call a fail action
			console.error(err);
		}
	},

	async deleteLineItem(lineItem)
	{
		AppDispatcher.handleAction({
			actionType: AppConstants.ACCOUNT_LINEITEM_DELETE_PENDING,
			lineItem
		});

		try
		{
			await Api.deleteLineItem(lineItem);
			await this.reloadAccountsAndBudgetAllocations(lineItem.accountId);
			AppDispatcher.handleAction({
				actionType: AppConstants.ACCOUNT_LINEITEM_DELETE_SUCCESS,
				lineItem
			});
		}
		catch (message)
		{
			console.error(message);
			AppDispatcher.handleAction({
				actionType: AppConstants.ACCOUNT_LINEITEM_DELETE_FAILURE,
				message
			});
		}
	},

	// Note: this is transaction has been saved, not saving a transaction
	transactionSaved(transaction)
	{
		AppDispatcher.handleAction({
			actionType: AppConstants.ACCOUNT_TRANSACTION_SAVE_SUCCESS,
			transaction
		});
	}
};



// WEBPACK FOOTER //
// ./Components/actions/AccountActions.jsx